module.exports = __webpack_public_path__ + "img/Jump Casting23.4e0f7aee.jpg";